import { useSearchState } from "common/router/hooks";

import TextButton from "client/common/components/buttons/TextButton";
import { INITIAL_CLIENT_DATA } from "client/common/utils";
import { AuthenticationSource } from "client/accounts/types";
import { Paths, urls } from "client/routes";

import LoginForm from "./LoginForm";
import AuthPage from "./AuthPage";

import styles from "../../styles/LoginPage.module.less";

const { auth_source: authSource } = INITIAL_CLIENT_DATA;

const LoginPage = () => {
  const [search] = useSearchState<Paths["accounts"]["login"]>({});

  const signinDescription =
    "Sign in using the phone number or email that you registered with when creating your online account.";

  const flash = search.flash
    ? `${search.flash}${
        authSource === AuthenticationSource.AutoAuth
          ? " If you believe this is an error, please contact our support team for help merging your acccounts."
          : ""
      }`
    : undefined;

  return (
    <AuthPage title="Welcome back!" description={signinDescription} flash={flash}>
      <div className={styles.form}>
        <LoginForm username={search.phone || search.email || ""} next={search.next} />
        <div className={styles.help}>
          <TextButton dest={urls.accounts.signup({ search })}>Sign Up</TextButton>
          <span className={styles.space}>·</span>
          <TextButton dest={urls.accounts.resetPassword({ search })}>Reset Password</TextButton>
        </div>
      </div>
    </AuthPage>
  );
};

export default LoginPage;
